// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingCom--container--2ZFtolB"};